import { Pipe, PipeTransform } from '@angular/core';
import { RiskRateEnum } from 'src/app/api/models/risks/risks.interface';
import { ContentPipe } from 'src/app/services/content/content.pipe';

@Pipe({
  standalone: true,
  name: 'riskCalculationText'
})
export class RiskCalulationToTextPipe implements PipeTransform {

  constructor(private contentPipe: ContentPipe) {}

  transform(risk: RiskRateEnum): string {
    if (!risk) {
      return '-';
    }
    return this.contentPipe.transform(`risks.${risk}`);
  }
}